import TutorialImage3 from "@/assets/images/tutorialPage3.png";
import { useTranslation } from "react-i18next";

function Page3() {
  const { t } = useTranslation("New");

  return (
    <div className="w-full flex flex-col gap-4 items-center">
      <div className="w-[500px] h-[250px]">
        <img src={TutorialImage3} alt="tutorial" />
      </div>

      <div className="flex flex-col gap-4 mt-7">
        <p className="font-medium text-center">{t("onboardingDesc3")}</p>
      </div>
    </div>
  );
}

export default Page3;
